export const useStyles = (theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 30,
  },
  buttonStyle: {
    variant: "contained",
    backgroundColor: "#eee !important",
    outlineColor: "#eee !important",
    fontSize: 20,
    textTransform: "none",
  },
});
